/* eslint-disable tailwindcss/no-arbitrary-value */
import { HTMLProps } from 'react';
import { cn } from '@ui/lib';
import { Body2 } from '@ui/components/tokens';

export interface SubSectionTitlePropsType {
  title: string;
  noPadding?: boolean;
}

export type SubSectionTitleProps = SubSectionTitlePropsType &
  HTMLProps<HTMLDivElement>;

export const SubSectionTitle = ({
  title,
  noPadding = false,
  ...rest
}: SubSectionTitleProps) => {
  return (
    <div
      className={cn(
        {
          'px-0': noPadding,
        },
        'inline-flex h-[44px] w-[375px] flex-col items-start justify-center',
        rest.className,
      )}
    >
      <div className="self-stretch" />
      <div className="inline-flex items-center justify-start gap-md self-stretch">
        <div className="inline-flex shrink grow basis-none flex-col items-start justify-start">
          <Body2 className="text-sm leading-none text-on-screen-surface-subdued">
            {title}
          </Body2>
        </div>
      </div>
      <div className="self-stretch" />
    </div>
  );
};
